const trMessages = {
  upload: {
      cancel: 'İptal',
      clearSelectedFiles: 'Temizle',
      dropFilesHere: 'Dosyalarınızı buraya bırakın',
      headerStatusUploaded: 'Tamamlandı',
      headerStatusUploading: 'Yükleniyor...',
      invalidFileExtension: 'Bu dosya türü yüklemeye izin verilmiyor.',
      invalidFiles: 'Geçersiz dosyalar. Lütfen yükleme gereksinimlerini kontrol edin.',
      invalidMaxFileSize: 'Dosya çok büyük.',
      invalidMinFileSize: 'Dosya çok küçük.',
      remove: 'Kaldır',
      retry: 'Tekrar dene',
      select: 'Dosyaları seç...',
      uploadSelectedFiles: 'Yükle',
      total: 'Toplam',
      files: 'dosyalar',
      selectTitle: 'Daha fazla dosya seçmek için tıklayın',
      selectNoFilesTitle: 'Seçili dosya yok',
      statusUploaded: 'Dosyalar başarıyla yüklendi.',
      statusUploadFailed: 'Dosya(lar) yüklenemedi.',
      dropZoneHint: 'Yüklemek için dosyaları buraya sürükleyip bırakın.',
      defaultDropZoneNote: '',
      dropZoneNote: 'Sadece {0} dosyaya izin verilir.'
  }
};
export default trMessages;
